module.exports = __webpack_public_path__ + "assets/img/assistant-module4.612bcfe7.png";